import moment from "moment"


export const InputsDates = (props) => {

    const { label = 'Fecha', name = "", value = new Date(), disabled, onHandleChange = null } = props
    // console.log('dates dates---', { name, value })

    return (
        <label>
            <span
                style={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    display: 'block'
                }}
            >
                {label}
            </span>
            <input
                type="date"
                name={name}
                value={moment(value).format('YYYY-MM-DD')}
                onChange={onHandleChange}
                disabled={disabled}
                style={{
                    padding: '7px',
                    border: '1px solid lightgray',
                    borderRadius: '4px',
                    fontSize: '16px',
                    backgroundColor: 'white'
                }}
            />
        </label>
    )
}